module.exports = __webpack_public_path__ + "img/be-careful-6-128.5aa00a2f.png";